import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ArrowRight, ArrowUp } from 'lucide-react';
import { contactInfo } from '../data/mock';
import { COOKIE_SETTINGS_EVENT } from '../lib/analytics';

const SERVICES_LINKS = [
  { name: 'SEO', href: '/diensten#seo' },
  { name: 'Google Ads', href: '/diensten#sea' },
  { name: 'Meta Ads', href: '/diensten#meta' },
  { name: 'TikTok Ads', href: '/diensten#tiktok' },
  { name: 'Backlinks', href: '/diensten#backlinks' },
  { name: 'Google Bedrijfsprofiel', href: '/diensten#gbp' },
  { name: 'Tracking', href: '/diensten#tracking' },
];

const PLATFORM_LINKS = [
  { name: 'Start gratis scan', href: '/register' },
  { name: 'Hoe het werkt', href: '/werkwijze' },
  { name: 'Prijzen', href: '/prijzen' },
  { name: 'Klantdashboard', href: '/klantdashboard' },
  { name: 'Inloggen', href: '/login' },
];

const COMPANY_LINKS = [
  { name: 'Over ons', href: '/over-ons' },
  { name: 'Diensten', href: '/diensten' },
  { name: 'Blog', href: '/blog' },
  { name: 'Vacatures', href: '/werken-bij' },
  { name: 'Partner worden', href: '/partner-worden' },
  { name: 'Contact', href: '/contact' },
];

export const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer style={{ background: 'linear-gradient(160deg, #0f172a 0%, #1e1b4b 60%, #0f172a 100%)', fontFamily: "'Inter', sans-serif" }}>

      {/* ── CTA banner ── */}
      <div style={{ borderBottom: '1px solid rgba(255,255,255,0.07)', padding: '56px 0' }}>
        <div className="container-custom">
          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: '24px' }}>
            <div>
              <p style={{ color: '#D4A017', fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '10px' }}>
                Begin gratis
              </p>
              <h2 style={{ fontFamily: "'Sora', sans-serif", fontSize: 'clamp(24px, 3vw, 36px)', fontWeight: 800, color: 'white', lineHeight: 1.2, margin: 0 }}>
                Scan uw bedrijf — direct<br className="hidden sm:block" /> uw groeikansen in beeld
              </h2>
            </div>
            <Link to="/register"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', background: 'linear-gradient(135deg, #D4A017, #f5c842)', color: '#0f172a', fontWeight: 700, fontSize: '15px', padding: '16px 32px', borderRadius: '100px', textDecoration: 'none', whiteSpace: 'nowrap', flexShrink: 0 }}>
              Start gratis scan <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </div>

      {/* ── Main footer grid ── */}
      <div className="container-custom" style={{ padding: '64px 24px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '40px' }}>

          {/* Brand */}
          <div style={{ gridColumn: 'span 1' }}>
            <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '12px', marginBottom: '20px', textDecoration: 'none' }}>
              <div style={{ width: '36px', height: '36px', background: '#D4A017', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <span style={{ color: '#0f172a', fontWeight: 800, fontSize: '18px' }}>♛</span>
              </div>
              <span style={{ fontFamily: "'Sora', sans-serif", color: 'white', fontWeight: 700, fontSize: '17px' }}>IMPERIA AI</span>
            </Link>
            <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: '14px', lineHeight: 1.7, marginBottom: '28px', maxWidth: '280px' }}>
              Gratis online groeiscan voor bedrijven. Ontdek wat uw bedrijf online mist en groei met ons platform of laat ons het uitvoeren.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <a href={`mailto:${contactInfo.email}`} style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'rgba(255,255,255,0.45)', fontSize: '13px', textDecoration: 'none', transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color='#D4A017'} onMouseLeave={e => e.target.style.color='rgba(255,255,255,0.45)'}>
                <Mail size={15} style={{ color: '#D4A017', flexShrink: 0 }} />{contactInfo.email}
              </a>
              <a href={`tel:${contactInfo.phone}`} style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'rgba(255,255,255,0.45)', fontSize: '13px', textDecoration: 'none', transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color='#D4A017'} onMouseLeave={e => e.target.style.color='rgba(255,255,255,0.45)'}>
                <Phone size={15} style={{ color: '#D4A017', flexShrink: 0 }} />{contactInfo.phone}
              </a>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'rgba(255,255,255,0.45)', fontSize: '13px' }}>
                <MapPin size={15} style={{ color: '#D4A017', flexShrink: 0 }} />{contactInfo.address}
              </div>
            </div>
          </div>

          {/* Diensten */}
          <div>
            <h4 style={{ color: '#D4A017', fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '20px' }}>Diensten</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '11px' }}>
              {SERVICES_LINKS.map(l => (
                <li key={l.name}>
                  <Link to={l.href} style={{ color: 'rgba(255,255,255,0.5)', fontSize: '14px', textDecoration: 'none', transition: 'color 0.2s' }}
                    onMouseEnter={e => e.target.style.color='white'} onMouseLeave={e => e.target.style.color='rgba(255,255,255,0.5)'}>
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Platform / Snel */}
          <div>
            <h4 style={{ color: '#D4A017', fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '20px' }}>Snel naar</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '11px' }}>
              {PLATFORM_LINKS.map(l => (
                <li key={l.name}>
                  <Link to={l.href} style={{ color: 'rgba(255,255,255,0.5)', fontSize: '14px', textDecoration: 'none', transition: 'color 0.2s' }}
                    onMouseEnter={e => e.target.style.color='white'} onMouseLeave={e => e.target.style.color='rgba(255,255,255,0.5)'}>
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Bedrijf */}
          <div>
            <h4 style={{ color: '#D4A017', fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '20px' }}>Bedrijf</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '11px' }}>
              {COMPANY_LINKS.map(l => (
                <li key={l.name}>
                  <Link to={l.href} style={{ color: 'rgba(255,255,255,0.5)', fontSize: '14px', textDecoration: 'none', transition: 'color 0.2s' }}
                    onMouseEnter={e => e.target.style.color='white'} onMouseLeave={e => e.target.style.color='rgba(255,255,255,0.5)'}>
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h4 style={{ color: '#D4A017', fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '20px' }}>Gratis starten</h4>
            <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: '13px', lineHeight: 1.65, marginBottom: '16px' }}>
              Ontvang direct uw persoonlijk groeidashboard. Geen creditcard nodig.
            </p>
            <Link to="/register"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: 'rgba(212,160,23,0.15)', border: '1px solid rgba(212,160,23,0.3)', color: '#D4A017', fontWeight: 700, fontSize: '13px', padding: '11px 20px', borderRadius: '10px', textDecoration: 'none' }}>
              Start gratis scan →
            </Link>
            <div style={{ marginTop: '24px', paddingTop: '24px', borderTop: '1px solid rgba(255,255,255,0.07)' }}>
              <p style={{ color: 'rgba(255,255,255,0.3)', fontSize: '12px', marginBottom: '8px' }}>Volg ons</p>
              <div style={{ display: 'flex', gap: '8px' }}>
                {['in', 'fb', 'ig'].map(s => (
                  <a key={s} href="#" style={{ width: '34px', height: '34px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,0.4)', fontSize: '11px', fontWeight: 700, textDecoration: 'none', transition: 'all 0.2s' }}
                    onMouseEnter={e => { e.target.style.background='#D4A017'; e.target.style.color='#0f172a'; }}
                    onMouseLeave={e => { e.target.style.background='rgba(255,255,255,0.06)'; e.target.style.color='rgba(255,255,255,0.4)'; }}>
                    {s}
                  </a>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* ── Trust strip ── */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.07)', padding: '20px 0' }}>
        <div className="container-custom" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '24px 48px' }}>
          {[['238+', 'Tevreden klanten'], ['€18M+', 'Gegenereerde omzet'], ['95%', 'Klantretentie'], ['8+', 'Jaar expertise']].map(([v, l]) => (
            <div key={l} style={{ textAlign: 'center' }}>
              <span style={{ color: '#D4A017', fontWeight: 700, fontSize: '17px' }}>{v} </span>
              <span style={{ color: 'rgba(255,255,255,0.35)', fontSize: '13px' }}>{l}</span>
            </div>
          ))}
        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.05)', padding: '18px 0' }}>
        <div className="container-custom" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
          <p style={{ color: 'rgba(255,255,255,0.25)', fontSize: '12px', margin: 0 }}>
            © {new Date().getFullYear()} IMPERIA AI · KVK 94755612 · Paxtonstraat 3n, 8013RP Zwolle
          </p>
          <div style={{ display: 'flex', gap: '20px' }}>
            <button data-testid="footer-cookie-settings-button" type="button" onClick={() => window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT))} style={{ background: 'none', border: 0, padding: 0, color: '#cbd5e1', fontSize: '12px', cursor: 'pointer' }}>Cookies</button>
            {['Privacybeleid', 'Algemene Voorwaarden'].map(l => (
              <a key={l} href="#" style={{ color: 'rgba(255,255,255,0.25)', fontSize: '12px', textDecoration: 'none', transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color='#D4A017'} onMouseLeave={e => e.target.style.color='rgba(255,255,255,0.25)'}>
                {l}
              </a>
            ))}
          </div>
          <button onClick={scrollToTop}
            style={{ width: '36px', height: '36px', background: '#D4A017', borderRadius: '9px', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.background='#B8860B'} onMouseLeave={e => e.currentTarget.style.background='#D4A017'}>
            <ArrowUp size={16} color="#0f172a" />
          </button>
        </div>
      </div>
    </footer>
  );
};
